export interface CompanyListing {
  rank: number
  name: string
  score: number
  badge: 'TOP PICK' | 'Excellent' | 'Good'
  stars: number
  features: string[]
  offer: string
}

export interface ServiceListings {
  serviceSlug: string
  serviceName: string
  description: string
  companies: CompanyListing[]
}

export const compareListings: ServiceListings[] = [
  {
    serviceSlug: 'walk-in-showers',
    serviceName: 'Walk-In Showers',
    description:
      'Avoid overspending on walk-in shower installation. See how our reviewers ranked the top walk-in shower companies in your area below.',
    companies: [
      {
        rank: 1,
        name: 'Safe Step',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'ADA-compliant designs',
          'Low-threshold entry for easy access',
          'Custom-fit to your bathroom',
          'Anti-slip flooring standard',
          'Lifetime warranty included',
          'Professional same-week installation',
        ],
        offer: 'Limited Time: $750 Off + Free Installation',
      },
      {
        rank: 2,
        name: 'Bath Fitter',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'One-day installation available',
          'Seamless acrylic walls — no grout',
          'Custom-measured for perfect fit',
          'Backed by lifetime warranty',
          'Dozens of style options',
        ],
        offer: 'Free In-Home Consultation',
      },
      {
        rank: 3,
        name: 'Re-Bath',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Full bathroom remodel options',
          'Accessibility-focused designs',
          'Durable, easy-to-clean surfaces',
          'Flexible financing available',
          'Licensed & insured installers',
        ],
        offer: 'Save Up To $1,000 This Month',
      },
    ],
  },
  {
    serviceSlug: 'walk-in-tubs',
    serviceName: 'Walk-In Tubs',
    description:
      'Find the best walk-in tub companies near you. Our reviewers evaluated safety features, hydrotherapy options, and installation quality.',
    companies: [
      {
        rank: 1,
        name: 'Kohler Walk-In Bath',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Hydrotherapy & BubbleMassage jets',
          'Ultra-low 3-inch step-in',
          'Heated backrest & surfaces',
          'Quick-drain technology',
          'Multifunction handshower included',
          'Lifetime limited warranty',
        ],
        offer: '$1,000 Off + No Payments for 18 Months',
      },
      {
        rank: 2,
        name: 'Safe Step Tubs',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Widest door in the industry',
          'Heated seat & backrest',
          'Micro-bubble therapy system',
          'Anti-slip floors & grab bars',
          'Lifetime warranty on tub & parts',
        ],
        offer: 'Free Shower Package Upgrade',
      },
      {
        rank: 3,
        name: 'American Standard',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Built-in grab bars & textured floor',
          'Quick drain — empties in under 2 min',
          'Whirlpool & air spa options',
          'Fits standard tub opening',
          'Nationwide dealer network',
        ],
        offer: 'Save $500 + Free Installation',
      },
    ],
  },
  {
    serviceSlug: 'stairlifts',
    serviceName: 'Stairlifts',
    description:
      'Compare the top-rated stairlift companies. Our experts evaluated safety, reliability, and value to help you choose the best option.',
    companies: [
      {
        rank: 1,
        name: 'Acorn Stairlifts',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Straight & curved stair models',
          'Battery backup for power outages',
          'Slim fold-away design',
          'Safety sensors on carriage & footrest',
          'Fast installation — often next day',
          'Industry-leading warranty',
        ],
        offer: '$250 Off + Free In-Home Survey',
      },
      {
        rank: 2,
        name: 'Bruno Stairlifts',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Made in the USA',
          'Whisper-quiet operation',
          'Offset swivel seat at top landing',
          '400 lb weight capacity available',
          'Covered gear rack for safety',
        ],
        offer: 'Free Home Assessment Today',
      },
      {
        rank: 3,
        name: 'Harmar Stairlifts',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Affordable pricing options',
          'Outdoor models available',
          'Retractable seat belt standard',
          'Easy-to-use armrest controls',
          'Nationwide service network',
        ],
        offer: 'Financing From $89/Month',
      },
    ],
  },
  {
    serviceSlug: 'window-replacement',
    serviceName: 'Window Replacement',
    description:
      'Avoid overspending on replacement windows for your home. See how our reviewers ranked the top window replacement and installation companies in your area below.',
    companies: [
      {
        rank: 1,
        name: 'Window Nation',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Licensed, bonded, & insured',
          'Over 1,000,000 windows installed',
          'Each window is custom made for your home',
          'Energy Glass is standard on all windows',
          'A+ BBB company accredited business',
          'Limited lifetime warranty',
        ],
        offer: 'Limited Time Offer! 50% Off + Zero Payments For 2 Years',
      },
      {
        rank: 2,
        name: 'Champion Windows',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Fast local pricing for windows',
          'Various window styles and options',
          'Energy efficient windows',
          'As little as 1-day installation',
          'Competitive warranties available',
        ],
        offer: 'Save Big On Windows Today',
      },
      {
        rank: 3,
        name: 'Renewal by Andersen',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Custom crafted, made to order',
          'Made to withstand the test of time',
          'Professionally installed',
          'Exclusive Fibrex® composite material',
          'Limited 20-year warranty',
        ],
        offer: 'Buy 1 Window, Get 1 40% Off',
      },
    ],
  },
  {
    serviceSlug: 'gutter-guards',
    serviceName: 'Gutter Guards',
    description:
      'Stop cleaning your gutters forever. See how our reviewers ranked the best gutter guard installation companies near you.',
    companies: [
      {
        rank: 1,
        name: 'LeafFilter',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          '#1 rated gutter guard in America',
          'Patented micro-mesh technology',
          'Fits existing gutters — no replacement needed',
          'Lifetime transferable warranty',
          'Professional installation included',
          'Handles up to 32 inches of rain/hour',
        ],
        offer: '15% Off Entire Purchase + 0% Financing',
      },
      {
        rank: 2,
        name: 'LeafGuard',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'One-piece seamless gutter system',
          'Built-in hood design deflects debris',
          'ScratchGuard® paint finish',
          'Lifetime no-clog guarantee',
          'Free in-home estimate',
        ],
        offer: '75% Off Labor + Free Estimate',
      },
      {
        rank: 3,
        name: 'All American Gutter Protection',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Stainless steel micro-mesh',
          'Works on all roof types',
          'No-clog performance guarantee',
          'Veteran-owned company',
          'Competitive pricing',
        ],
        offer: 'Free Gutter Inspection + Quote',
      },
    ],
  },
  {
    serviceSlug: 'roofing',
    serviceName: 'Roofing',
    description:
      'Protect your home with a quality roof. See how our reviewers ranked the top roofing contractors and companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'DaBella Roofing',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'GAF Master Elite® certified contractor',
          'Premium shingle options available',
          'Full roof system installation',
          'Comprehensive workmanship warranty',
          'Free drone roof inspection',
          'Financing options available',
        ],
        offer: '$1,000 Off Full Roof Replacement',
      },
      {
        rank: 2,
        name: 'Roof.com',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Instant online roof estimates',
          'Vetted local contractor network',
          'Price-match guarantee',
          'Insurance claim assistance',
          'Satisfaction guaranteed',
        ],
        offer: 'Get Your Free Instant Estimate',
      },
      {
        rank: 3,
        name: 'Long Roofing',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          '50+ years in business',
          'Owens Corning Platinum Preferred',
          'Lifetime workmanship warranty',
          'Energy-efficient options',
          'Flexible financing plans',
        ],
        offer: '$500 Off + Free Upgrades',
      },
    ],
  },
  {
    serviceSlug: 'siding',
    serviceName: 'Siding',
    description:
      "Transform your home's exterior with new siding. See how our reviewers ranked the top siding installation companies near you.",
    companies: [
      {
        rank: 1,
        name: 'DaBella Siding',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium vinyl & fiber cement options',
          'Insulated siding for energy savings',
          'Color that never needs painting',
          'Lifetime limited warranty',
          'Expert installation crews',
          'Free in-home consultation',
        ],
        offer: '$1,500 Off Whole-Home Siding',
      },
      {
        rank: 2,
        name: 'Window World Siding',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Affordable pricing guaranteed',
          'Multiple material options',
          'Energy Star® certified products',
          'Lifetime limited warranty',
          'Locally owned & operated',
        ],
        offer: 'Free Estimate + No Money Down',
      },
      {
        rank: 3,
        name: 'Power Home Remodeling',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Premium insulated siding',
          'Reduces energy costs up to 20%',
          'Custom color matching',
          'Backed by manufacturer warranty',
          'A+ BBB rating',
        ],
        offer: 'Save Up To $2,000 This Season',
      },
    ],
  },
  {
    serviceSlug: 'solar',
    serviceName: 'Solar Panels',
    description:
      'Go solar and save on energy bills. See how our reviewers ranked the top solar panel installation companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'SunPower',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Highest efficiency panels on the market',
          '25-year complete confidence warranty',
          'Sleek all-black panel design',
          'Integrated battery storage options',
          'Professional design & installation',
          'Industry-leading energy production',
        ],
        offer: 'Get 30% Federal Tax Credit + $0 Down',
      },
      {
        rank: 2,
        name: 'Tesla Solar',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Low-profile panel design',
          'Powerwall battery integration',
          'Price-match guarantee',
          'Mobile app monitoring',
          'Simple online ordering',
        ],
        offer: 'Price Match Guarantee + Free Powerwall',
      },
      {
        rank: 3,
        name: 'ADT Solar',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Backed by ADT brand trust',
          'Premium panel options',
          '25-year warranty coverage',
          'Flexible financing available',
          'Nationwide installation network',
        ],
        offer: '$0 Down Solar Installation',
      },
    ],
  },
  {
    serviceSlug: 'bathroom-remodel',
    serviceName: 'Bathroom Remodel',
    description:
      'Create your dream bathroom. See how our reviewers ranked the top bathroom remodeling companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Re-Bath',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Full bathroom transformations',
          'One-day tub & shower installs available',
          'Durable, low-maintenance materials',
          'ADA-accessible options',
          'Lifetime warranty on products',
          'Licensed & insured professionals',
        ],
        offer: '$1,000 Off Complete Remodel',
      },
      {
        rank: 2,
        name: 'Bath Fitter',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Custom-measured acrylic solutions',
          'Installed over existing fixtures',
          'No demolition required',
          'Seamless walls — no grout to clean',
          'Lifetime warranty',
        ],
        offer: 'Free In-Home Design Consultation',
      },
      {
        rank: 3,
        name: 'Luxury Bath',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Premium design options',
          'Quick 1-2 day installation',
          'Mold & mildew resistant materials',
          'Accessibility upgrades available',
          'Flexible financing',
        ],
        offer: 'Save $500 + Free Accessories',
      },
    ],
  },
  {
    serviceSlug: 'kitchen-remodel',
    serviceName: 'Kitchen Remodel',
    description:
      'Revitalize the heart of your home. See how our reviewers ranked the top kitchen remodeling companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Kitchen Magic',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Cabinet refacing saves 50% vs. replacing',
          'Granite & quartz countertop options',
          'Custom storage solutions',
          'Professional design team included',
          'Lifetime warranty on refacing',
          'Financing from $99/month',
        ],
        offer: 'Up To $3,000 Off Kitchen Remodel',
      },
      {
        rank: 2,
        name: 'N-Hance Wood Refinishing',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Cabinet refinishing in 1-2 days',
          'Fraction of replacement cost',
          'Eco-friendly lightspeed® finish',
          'Color change options available',
          'Nationwide franchise network',
        ],
        offer: 'Free Color Consultation + Estimate',
      },
      {
        rank: 3,
        name: 'CliqStudios',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Custom cabinetry at fair prices',
          'Free 3D kitchen design',
          'Solid wood construction',
          'Soft-close doors & drawers standard',
          'Delivered to your door',
        ],
        offer: '40% Off MSRP + Free Design',
      },
    ],
  },
  {
    serviceSlug: 'flooring',
    serviceName: 'Flooring',
    description:
      'Upgrade your floors with confidence. See how our reviewers ranked the top flooring installation companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Empire Today',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Shop-at-home convenience',
          'Next-day professional installation',
          'Hundreds of styles in stock',
          'All-inclusive pricing — no hidden fees',
          'Satisfaction guarantee included',
          'Financing options available',
        ],
        offer: 'Buy One Room, Get One Free',
      },
      {
        rank: 2,
        name: 'Floor & Decor',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Largest in-stock selection',
          'Wholesale pricing direct to you',
          'Free design services',
          'Professional installation available',
          'Price match guarantee',
        ],
        offer: 'Free Installation On Select Floors',
      },
      {
        rank: 3,
        name: 'LL Flooring',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Hardwood & luxury vinyl specialists',
          'Competitive everyday pricing',
          'Free samples shipped to your door',
          'Professional installation network',
          'Extensive warranty coverage',
        ],
        offer: 'Up To 30% Off Select Styles',
      },
    ],
  },
  {
    serviceSlug: 'hvac',
    serviceName: 'HVAC',
    description:
      'Keep your home comfortable year-round. See how our reviewers ranked the top HVAC installation and repair companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Trane Comfort Specialists',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium Trane equipment',
          'Up to 22 SEER2 efficiency ratings',
          'Factory-trained technicians',
          '12-year limited warranty',
          'Smart thermostat integration',
          'Financing as low as 0% APR',
        ],
        offer: '$1,500 Off New System + Free Thermostat',
      },
      {
        rank: 2,
        name: 'Carrier Factory Authorized',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Carrier brand reliability',
          'Energy Star® certified systems',
          'Indoor air quality solutions',
          '10-year parts warranty',
          'Same-day service available',
        ],
        offer: 'Up To $1,200 In Rebates',
      },
      {
        rank: 3,
        name: 'Lennox Premier Dealers',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Quietest systems available',
          'iComfort smart technology',
          'Variable-speed compressors',
          'Comprehensive maintenance plans',
          'Satisfaction guarantee',
        ],
        offer: 'Special Financing For 60 Months',
      },
    ],
  },
  {
    serviceSlug: 'painting',
    serviceName: 'Painting',
    description:
      'Refresh your home with a professional paint job. See how our reviewers ranked the top painting companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'CertaPro Painters',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Largest residential painting company',
          'Detailed written estimates',
          'Premium Sherwin-Williams paints',
          'Interior & exterior specialists',
          'Satisfaction guarantee included',
          'Fully licensed & insured',
        ],
        offer: '10% Off Your First Project',
      },
      {
        rank: 2,
        name: 'Five Star Painting',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Neighborly® brand backed',
          'Free color consultations',
          'Eco-friendly paint options',
          'On-time guarantee',
          'Background-checked painters',
        ],
        offer: 'Free Estimate + Color Consultation',
      },
      {
        rank: 3,
        name: 'Paintzen',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Instant online quotes',
          'Vetted professional painters',
          'Premium Benjamin Moore paints',
          'Hassle-free booking',
          'Satisfaction guaranteed',
        ],
        offer: 'Book Online & Save $100',
      },
    ],
  },
  {
    serviceSlug: 'plumbing',
    serviceName: 'Plumbing',
    description:
      'Fix leaks and upgrade your plumbing. See how our reviewers ranked the top plumbing service companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Roto-Rooter',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Available 24/7/365',
          'Over 85 years of experience',
          'Flat-rate pricing — no surprises',
          'Licensed & insured plumbers',
          'Drain cleaning specialists',
          'Satisfaction guaranteed',
        ],
        offer: '$50 Off Any Plumbing Service',
      },
      {
        rank: 2,
        name: 'Mr. Rooter Plumbing',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Neighborly® brand trusted',
          'Upfront, flat-rate pricing',
          'No overtime charges — ever',
          'Full-service plumbing',
          'Courteous, uniformed plumbers',
        ],
        offer: 'Free Plumbing Inspection',
      },
      {
        rank: 3,
        name: 'Benjamin Franklin Plumbing',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          "On-time guarantee or you don't pay",
          'Straightforward pricing',
          'Background-checked technicians',
          'Residential & commercial',
          'Financing available',
        ],
        offer: '$25 Off First Service Call',
      },
    ],
  },
  {
    serviceSlug: 'electrical',
    serviceName: 'Electrical',
    description:
      'Keep your home safe and powered. See how our reviewers ranked the top electrical service companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Mr. Electric',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Neighborly® brand backed',
          'Upfront pricing — no surprises',
          'Licensed master electricians',
          'Residential & commercial services',
          'Code compliance experts',
          'Satisfaction guaranteed',
        ],
        offer: '$50 Off Any Electrical Service',
      },
      {
        rank: 2,
        name: 'Mister Sparky',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'On-time guarantee',
          'Flat-rate pricing always',
          'Safety inspections available',
          'EV charger installation',
          'Background-checked electricians',
        ],
        offer: 'Free Home Safety Inspection',
      },
      {
        rank: 3,
        name: 'Arc Angel Electric',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Panel upgrades & rewiring',
          'Smart home installation',
          'Generator installation',
          'Surge protection specialists',
          'Flexible scheduling',
        ],
        offer: '10% Off Panel Upgrades',
      },
    ],
  },
  {
    serviceSlug: 'fencing',
    serviceName: 'Fencing',
    description:
      'Add privacy and security to your property. See how our reviewers ranked the top fence installation companies in your area.',
    companies: [
      {
        rank: 1,
        name: "Lowe's Fence Installation",
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Trusted national brand',
          'Wide selection of materials & styles',
          'Professional installation included',
          'Competitive pricing guaranteed',
          'Project financing available',
          'Free in-store consultations',
        ],
        offer: '10% Off Fence Installation',
      },
      {
        rank: 2,
        name: 'Home Depot Fencing',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Huge material selection',
          'Licensed local installers',
          'Free project estimates',
          'Wood, vinyl, chain link & more',
          'Installation warranty included',
        ],
        offer: 'Free Delivery On Materials',
      },
      {
        rank: 3,
        name: 'Ergeon Fencing',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Instant online quotes',
          'AI-powered project planning',
          '3D fence visualization',
          'Vetted local contractors',
          'Price-lock guarantee',
        ],
        offer: 'Get Instant Quote Online',
      },
    ],
  },
  {
    serviceSlug: 'insulation',
    serviceName: 'Insulation',
    description:
      'Lower your energy bills with proper insulation. See how our reviewers ranked the top insulation companies near you.',
    companies: [
      {
        rank: 1,
        name: 'USA Insulation',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium injection foam insulation',
          'Reduces energy bills up to 40%',
          'No demolition or mess',
          'Lifetime warranty included',
          'Free energy assessment',
          'Financing options available',
        ],
        offer: '10% Off Whole-Home Insulation',
      },
      {
        rank: 2,
        name: 'Dr. Energy Saver',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Comprehensive energy audits',
          'Spray foam & blown-in options',
          'Attic, wall & crawl space experts',
          'Certified energy specialists',
          'Measurable energy savings',
        ],
        offer: 'Free Energy Audit ($500 Value)',
      },
      {
        rank: 3,
        name: 'Installed Building Products',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Largest insulation installer in US',
          'All insulation types available',
          'New construction & retrofit',
          'Commercial & residential',
          'Nationwide coverage',
        ],
        offer: 'Free Insulation Assessment',
      },
    ],
  },
  {
    serviceSlug: 'doors',
    serviceName: 'Doors',
    description:
      "Upgrade your home's entry and security. See how our reviewers ranked the top door replacement companies in your area.",
    companies: [
      {
        rank: 1,
        name: 'Pella Doors',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Premium wood, fiberglass & steel options',
          'Custom sizes & configurations',
          'Energy-efficient designs',
          'Limited lifetime warranty',
          'Professional measurement & install',
          'Showroom design consultations',
        ],
        offer: 'Up To $500 Off Entry Doors',
      },
      {
        rank: 2,
        name: 'Therma-Tru Doors',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          '#1 brand used by builders',
          'Fiberglass that looks like real wood',
          'Superior weather resistance',
          'Extensive glass options',
          'Lifetime limited warranty',
        ],
        offer: 'Free In-Home Consultation',
      },
      {
        rank: 3,
        name: 'Home Depot Door Install',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Wide selection of brands & styles',
          'Professional local installers',
          'Competitive pricing',
          'Free measurement service',
          'Installation warranty',
        ],
        offer: 'Free Measurement + 10% Off Install',
      },
    ],
  },
  {
    serviceSlug: 'garage-doors',
    serviceName: 'Garage Doors',
    description:
      'Boost your curb appeal with a new garage door. See how our reviewers ranked the top garage door companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Clopay Garage Doors',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          "America's favorite garage door brand",
          'Insulated & non-insulated options',
          'Wind load rated models available',
          'Extensive design customization',
          'Limited lifetime warranty',
          'Nationwide dealer network',
        ],
        offer: 'Free Design Consultation + Estimate',
      },
      {
        rank: 2,
        name: 'Precision Door Service',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Same-day service available',
          'Repair & replacement experts',
          'Lifetime warranty on springs',
          'Smart garage door openers',
          'Upfront pricing always',
        ],
        offer: '$100 Off New Garage Door',
      },
      {
        rank: 3,
        name: 'Overhead Door Company',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          '90+ years of experience',
          'Residential & commercial',
          'Smart technology integration',
          'Energy-efficient insulated doors',
          'Professional installation',
        ],
        offer: 'Free Safety Inspection',
      },
    ],
  },
  {
    serviceSlug: 'home-security',
    serviceName: 'Home Security',
    description:
      'Protect your family and property. See how our reviewers ranked the top home security system companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'ADT Security',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          '145+ years of trusted protection',
          '24/7 professional monitoring',
          'Smart home integration',
          'Video doorbell & cameras included',
          '6-month money-back guarantee',
          'Professional installation',
        ],
        offer: 'Free Equipment + $0 Installation',
      },
      {
        rank: 2,
        name: 'Vivint Smart Home',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'AI-powered smart detection',
          'Professional-grade cameras',
          'Smart lock & thermostat integration',
          'Custom system design',
          'Award-winning app',
        ],
        offer: 'Free Professional Installation',
      },
      {
        rank: 3,
        name: 'SimpliSafe',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'No contracts required',
          'Easy DIY installation',
          'Professional monitoring from $17.99/mo',
          'Fast Protect™ technology',
          'Award-winning design',
        ],
        offer: '40% Off Security System',
      },
    ],
  },
  {
    serviceSlug: 'pest-control',
    serviceName: 'Pest Control',
    description:
      'Eliminate pests and protect your home. See how our reviewers ranked the top pest control companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'Terminix',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          '90+ years of pest expertise',
          'Termite & general pest control',
          'Satisfaction guarantee included',
          'Customized treatment plans',
          'Trained & certified technicians',
          'Flexible scheduling',
        ],
        offer: '$50 Off Initial Treatment',
      },
      {
        rank: 2,
        name: 'Orkin',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Over 120 years in business',
          'A.I.M. treatment methodology',
          'Ongoing pest prevention',
          'Money-back guarantee',
          'Highly trained specialists',
        ],
        offer: 'Free Pest Inspection',
      },
      {
        rank: 3,
        name: 'Aptive Environmental',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Eco-friendly treatments',
          'Family & pet safe products',
          'Quarterly service plans',
          'No long-term contracts',
          'Fast-growing pest company',
        ],
        offer: '$50 Off First Service',
      },
    ],
  },
  {
    serviceSlug: 'landscaping',
    serviceName: 'Landscaping',
    description:
      'Create your dream outdoor space. See how our reviewers ranked the top landscaping companies in your area.',
    companies: [
      {
        rank: 1,
        name: 'TruGreen',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          "America's #1 lawn care company",
          'Science-based lawn treatments',
          'Tailored plans for your region',
          'Satisfaction guarantee included',
          'PhD-certified specialists',
          'Year-round lawn programs',
        ],
        offer: '50% Off First Application',
      },
      {
        rank: 2,
        name: 'Lawn Love',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Instant online booking',
          'Vetted local landscapers',
          'Transparent upfront pricing',
          'Mowing, trimming & more',
          'Satisfaction guaranteed',
        ],
        offer: 'First Mow Free For New Customers',
      },
      {
        rank: 3,
        name: 'BrightView Landscapes',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Full-service landscape design',
          'Commercial & residential',
          'Irrigation & hardscape experts',
          'Seasonal maintenance plans',
          'Nationwide coverage',
        ],
        offer: 'Free Landscape Consultation',
      },
    ],
  },
  {
    serviceSlug: 'cleaning',
    serviceName: 'Cleaning',
    description:
      'Keep your home spotless with professional cleaning. See how our reviewers ranked the top cleaning service companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Molly Maid',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Neighborly® brand trusted',
          'Customized cleaning plans',
          'Insured & bonded teams',
          'Satisfaction guarantee included',
          'Consistent, reliable scheduling',
          'Background-checked employees',
        ],
        offer: '$50 Off First Clean',
      },
      {
        rank: 2,
        name: 'Merry Maids',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          '35+ years of experience',
          'Worry-free guarantee',
          'Eco-friendly cleaning options',
          'Trained & vetted professionals',
          'Flexible scheduling',
        ],
        offer: 'Free In-Home Estimate',
      },
      {
        rank: 3,
        name: 'The Maids',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          '22-step healthy touch cleaning',
          'HEPA filtration vacuums',
          'EPA-registered disinfectants',
          'Team cleaning for faster service',
          'Satisfaction guaranteed',
        ],
        offer: '10% Off Recurring Service',
      },
    ],
  },
  {
    serviceSlug: 'general',
    serviceName: 'General Repair',
    description:
      'Tackle your home repairs with trusted handymen. See how our reviewers ranked the top general repair and handyman companies near you.',
    companies: [
      {
        rank: 1,
        name: 'Mr. Handyman',
        score: 9.9,
        badge: 'TOP PICK',
        stars: 5,
        features: [
          'Neighborly® brand backed',
          'Wide range of repair services',
          'Upfront, flat-rate pricing',
          'Licensed & insured craftsmen',
          'Satisfaction guarantee included',
          'One call handles it all',
        ],
        offer: '$25 Off First Service',
      },
      {
        rank: 2,
        name: 'Ace Handyman Services',
        score: 9.7,
        badge: 'Excellent',
        stars: 5,
        features: [
          'Craftsmen — not subcontractors',
          'Multi-skilled professionals',
          'Background-checked & insured',
          'On-time guarantee',
          'Locally owned & operated',
        ],
        offer: 'Free Project Consultation',
      },
      {
        rank: 3,
        name: 'Handy',
        score: 9.5,
        badge: 'Good',
        stars: 4,
        features: [
          'Easy online booking',
          'Vetted local professionals',
          'Transparent pricing',
          'Furniture assembly to full repairs',
          'Happiness guarantee',
        ],
        offer: 'First Booking 20% Off',
      },
    ],
  },
]
